<template>
  <div class="user_body" v-loading="loading">
    <span class="title">投诉建议</span>
    <div class="user_item2">
      <span>*</span>
      <span>文章标题：</span>
      <el-input v-model="form.title" placeholder="文章标题" class="input_size" size="small"></el-input>
    </div>
    <div class="user_item2">
      <span>*</span>
      <span>所属栏目：</span>
      <el-select v-model="form.category_id" slot="prepend" placeholder="请选择" class="input_size" size="small">
        <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="user_item3"> 
      <span>TG标签：</span>
      <el-input v-model="form.label"  placeholder="多个标签之间用逗号隔开" class="input_size" size="small"></el-input>
    </div>



    <div class="user_item3"> 
      <span>缩略图：</span>
      <el-upload action="#" :auto-upload="false" :file-list="imageFileList" list-type="picture-card" :on-remove="handleRemove"
        :on-change="handleUploadChange">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
    <div class="user_item3">
      <span>内容详情：</span>
      <Editer v-model="form.content"/>
    </div>
     
    <div class="user_item">
      <span></span>
      <span class="btns" @click="submitFeedback">确认提交</span>
    </div>
  </div>
</template>
<script>
import Editer from "../../components/Editer"; 
export default {
   components: {
    Editer, 
  },
  name: "UserInfoView",
  data() {
    return {
      list: [{}, {}, {}, {}],
      categoryList: [],
      loading:false,
      imageFileList: [],
      form:{
        category_id: "",
        title: "",
        label: "",
        thumb: "",
        content: ""
      }
    };
  },
  created(){
    this.getCategoryList()
    if(this.$route.params.id){
      this.getSuggestionDetail()
    }
  },
  mounted() {},
  methods: {
    getSuggestionDetail(){
      this.$api.getFeedbackDetail({id:this.$route.params.id}).then(res=>{
        if(res.code==1){
          this.form = {
            id: res.data.info.id,
            category_id: res.data.info.category_id,
            title: res.data.info.title,
            label: res.data.info.label,
            thumb: res.data.info.thumb,
            content: res.data.info.content
      }
          
          this.imageFileList = [{url:res.data.info.thumb}]
        }
      })
    },
    handleUploadChange(file, fileList) {
      this.imageFileList = []
    this.$api.upload({
      file: file.raw
    }).then(res => {
      if (res.code === 1) {
        this.form.thumb = res.data.fullurl;
        this.imageFileList = [{url:res.data.fullurl}]

      }else{
        this.$message.error(res.message);
        this.imageFileList = fileList
      }
    }).catch(err => {
      console.log(err);
      this.$message.error('上传失败');
    });
  },
  handleRemove(file,fileList) {
      // 移除图片
      this.form.thumb = ""
      this.imageFileList = fileList
    },
    getCategoryList(){
      this.$api.getFeedbackCategoryList().then(res=>{
        if(res.code==1){
          this.categoryList = res.data.list
        }
      }).catch(err=>{
        console.log(err)
      })

    },
    submitFeedback(){
      console.log('提交feedback',this.form)
      this.loading = true
      this.$api.submitFeedback(this.form).then(res=>{
        if(res.code==1){
          this.$message.success(res.message)
          this.$router.push('/suggestionsview')
        }else{
          this.$message.error(res.message)
        }
        this.loading = false
      }).catch(err=>{
        console.log(err)
        this.loading = false
      }).finally(()=>{
        this.loading = false
      })

    }
  }
};
</script> 
<style lang="less" scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
}
.title {
  color: #666666;
  font-size: 16px;
}
.user_item2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
}
.user_item2 span:nth-child(odd) {
  font-size: 14px;
  color: red;
  text-align: right;
  width: 10px;
}
.user_item2 span:nth-child(even) {
  width: 70x;
  font-size: 14px;
  color: #999999;
  text-align: right; 
}
.user_item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
}
.user_item span:nth-child(odd) {
  width:80px;
  font-size: 14px;
  color: #999999;
  text-align: right;
}

.user_item3 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 15px;
}
.user_item3 span:nth-child(odd) {
  width: 80px;
  font-size: 14px;
  color: #999999;
  text-align: right;
}
.text1 {
  font-size: 14px;
  color: #999999;
}
.text2 {
  font-size: 14px;
  color: #3c9c8f;
}
.user_icon {
  width: 70px;
  height: 70px;
  border-radius: 70px;
}
.input_size {
  width: 300px;
}
.btns {
  cursor: pointer;
  width: 160px;
  height: 40px;
  color: #ffffff;
  background: #3c9c8f;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  margin-top: 20px;
}
:deep(.el-select) {
  width: 300px!important;
}
</style>
<style>
.el-upload--picture-card {
    background-color: #ffffff!important; 
    border: 1px dashed #c0ccda;
     border-radius: 0px !important; 
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
}
</style>

